<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-stats card-raised">
          <div class="card-body">
            <div class="row" style="font-size: 12px">
              <div class="col">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-primary">
                      <i class="now-ui-icons shopping_cart-simple"></i>
                    </div>
                    <h3 class="info-title">
                      <small>R$</small>
                    </h3>
                    <h6 class="stats-title">Vendas do Dia</h6>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-info">
                      <i class="now-ui-icons business_chart-bar-32"></i> 
                    </div>
                    <h3 class="info-title">
                      <small>R$</small>
                    </h3>
                    <h6 class="stats-title">Vendas do Mês</h6>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-success">
                      <i class="now-ui-icons business_money-coins"></i>
                    </div>
                    <h3 class="info-title">
                      <small>R$</small>
                    </h3>
                    <h6 class="stats-title">Ticket Médio</h6>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-warning" style='color:#8e44ad;'>
                      <i class="fa fa-pencil-square-o"></i>
                    </div>
                    <h3 class="info-title">
                    </h3>
                    <h6 class="stats-title">Pedidos Dia</h6>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-default">
                      <i class="now-ui-icons shopping_shop"></i>
                    </div>
                    <h3 class="info-title">
                    </h3>
                    <h6 class="stats-title">Pedidos Mês</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-lg-6">
        <card class="card-chart" no-footer-line>
          <div slot="header">
            <h5 class="card-category">Vendas por produto</h5>

          </div>
          <div class="chart-area">
          <!--   <line-chart :labels="charts.emailsCampaign.labels"
            :data="charts.emailsCampaign.data"
            :color="charts.emailsCampaign.color"
            :height="200">
          </line-chart> -->

          <line-chart-reactive 
            :chart-data="charts.emailsCampaign" 
            :options="charts.emailsCampaignOptions"
            :height="200"
          ></line-chart-reactive>
        </div>
        <div class="card-progress">
          <n-progress type="secondary" :height="2" v-for="item of reverseItems.slice(0, 5)" :label="item.label" :value="item.percent" show-value></n-progress>
        </div>
        <div slot="footer" class="stats">
          <!-- <i class="now-ui-icons arrows-1_refresh-69"></i> Just Updated -->
        </div>
      </card>
    </div>
    <div class="col-lg-6" >
      <card class="card-chart" no-footer-line>
        <div slot="header">
          <h5 class="card-category">Forma de Pagamento</h5>
          <h5 class="card-title">
          </h5>
        </div>
        <div class="">
          <pie-chart
            :chart-data="charts.formaPagamento" 
            :options="charts.formaPagamentoOptions"
            :height="300"
          ></pie-chart>
        </div>
      </card>
    </div>

  </div>

  <div class="row">

    <div class="col-lg-6">
      <card class="card-chart" no-footer-line style='display: block !important;'>
        <div slot="header">
          <h5 class="card-category">Vendas por Horário</h5>
        </div>

        <bar-chart-reactive
          :chart-data="charts.vendasHorario" 
          :options="charts.vendasHorarioOptions"
          :height="400"
        ></bar-chart-reactive>
    </card>
  </div>
  <div class="col-lg-6" >
    <card class="card-chart" no-footer-line>
      <div slot="header">
        <h5 class="card-category">Dia da Semana</h5>
        <h5 class="card-title">
        </h5>
      </div>
      <div class="">

          <doughnut-chart
            :chart-data="charts.diaSemana" 
            :options="charts.diaSemanaOptions"
            :height="300"
          ></doughnut-chart>
        <!-- <canvas id="DiaSemana"></canvas> -->
      </div>
    </card>

    
  </div>
  <div class="col-lg-12" >
      <card class="card-chart" no-footer-line>
        <div slot="header">
          <h5 class="card-category">Vendas Por Dia Do Mês</h5>
        </div>
        <div class="">
          <line-chart-reactive
            :chart-data="charts.venda_dias_mes" 
            :options="charts.venda_dias_mes_options"
          ></line-chart-reactive>
        </div>
      </card>
    </div>
  <canvas id="canvasDoido" style="display: none;"></canvas>
  <canvas id="lcCanvasDoido" style="display: none;"></canvas>

</div>
</div>


</template>
<script>
  import {
    Card,
    Progress as NProgress,
    LineChart,
    LineChartReactive,
    PieChart,
    BarChart,
    DoughnutChart,
    BarChartReactive
  } from 'src/components'
  import { setInterval } from 'timers';
  import moment from 'moment'
  import { Chart } from 'chart.js';
  import GlobalFunctions from '../../../globalFunctions'
  import { EventBus } from '@/services/EventBus.js'
  import {hexToRGB} from "@/components/Charts/utils";

  export default {
    components: {
      Card,
      LineChart,
      LineChartReactive,
      BarChart,
      BarChartReactive,
      PieChart,
      NProgress,
      Chart,
      DoughnutChart
    },
    computed: {
      reverseItems() {
          return this.charts.emailsCampaignDesc.slice().reverse();
      }     
    },
    data() {
      return {
        data_inicio: moment().startOf('month').format("YYYY-MM-DD"),
        progress: 0,
        vendas_dia: 33,
        vendas_mes:230,
        ticket_medio:60,
        cabecalho: [],
        barChart1: {
          labels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          data: [80, 99, 86, 96, 123, 85, 100, 75, 88, 90, 123, 155],
          color: '#2CA8FF',
          title: 'Active Countries'
        },
        grafico1:null,
        grafico2:null,
        charts: {
          vendasHorario: {

          },
          venda_dias_mes: {

          },

          venda_dias_mes_options: {

            responsive: true,
            width:'100%',
            maintainAspectRatio: false,
            height:'200px',
            title: {
              display: true,
            },
            legend:{
              position:'bottom'
            },
            scales: {
              xAxes: [{
                  ticks: {
                      autoSkip: true,
                      maxTicksLimit: 10
                  }
              }]
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10,
              callbacks: {
                  label: function(tooltipItems, data) { 
                      return "R$ " + tooltipItems.yLabel;
                  }
              }
            }
          },
          vendasHorarioOptions: {

            responsive: true,
            width:'100%',
            height:'',
            title: {
              display: true,
              // text: 'Valores em Reais'
            },
            legend:{
              position:'bottom'
            },
            maintainAspectRatio: false,
            legend: {
              display: true
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10,
              callbacks: {
                  label: function(tooltipItems, data) { 
                      return "R$ " + tooltipItems.yLabel;
                  }
              }
            },
            responsive: 1,
            scales: {
              yAxes: [{
                gridLines: {
                  zeroLineColor: "transparent",
                  drawBorder: false
                }
              }],
              xAxes: [{
                gridLines: {
                  zeroLineColor: "transparent",
                  drawTicks: true,
                  display: true,
                  drawBorder: false
                }
              }]
            },
            layout: {
              padding: {left: 0, right: 0, top: 15, bottom: 15}
            },




          },
          formaPagamento: {

          },
          formaPagamentoOptions: {
            responsive: true,
            title: {
              display: true,
              text: 'Valores em Reais'
            },
            legend:{
              display:true
            }
          },
          diaSemana: {

          },
          diaSemanaOptions: {
          type: 'doughnut',
            responsive: true,
            title: {
              display: true,
              text: 'Valores em Reais'
            },
            legend:{
              position:'bottom',
              display:true
            }
            
          },

          emailsCampaign: {
            labels: []
          },
          emailsCampaignDesc: [],
          emailsCampaignOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            tooltips: {
              bodySpacing: 4,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
              xPadding: 10,
              yPadding: 10,
              caretPadding: 10,
              callbacks: {
                  label: function(tooltipItems, data) { 
                      return "R$ " + tooltipItems.yLabel;
                  }
              }
            },
            responsive: 1,
            scales: {
              yAxes: [{
                display: 0,
                ticks: {
                  display: false
                },
                gridLines: {
                  zeroLineColor: "transparent",
                  drawTicks: false,
                  display: false,
                  drawBorder: false
                }
              }],
              xAxes: [{
                display: 0,
                ticks: {
                  display: false
                },
                gridLines: {
                  zeroLineColor: "transparent",
                  drawTicks: false,
                  display: false,
                  drawBorder: false
                }
              }]
            },
            layout: {
              padding: {left: 0, right: 0, top: 15, bottom: 15}
            }
          }
        }
      }
    },
    methods: {
      formatToPrice(vendas_mes) {
        return `R$ ${vendas_mes.toFixed(2)}`;
      },
      inicializarGraficoVendaPagamento(tabela){
        if(this.grafico1 != null)
          this.grafico1.destroy();

        let ctx2 = document.getElementById("DiaSemana").getContext('2d');

        if(this.grafico2 != null)
          this.grafico2.destroy();

        this.grafico2 = new Chart(ctx2,{
          type: 'doughnut',
          data: {
            datasets: [{
              data: [90,100,180,400,250,90,300],
              backgroundColor: [
              GlobalFunctions.corAleatoria(),
              GlobalFunctions.corAleatoria(),
              GlobalFunctions.corAleatoria(),
              GlobalFunctions.corAleatoria(),
              GlobalFunctions.corAleatoria(),
              GlobalFunctions.corAleatoria(),
              GlobalFunctions.corAleatoria()
              ],
              label: 'Dataset 1'
            }],
            labels: [
            'Segunda-Feira',
            'Terça-Feira',
            'Quarta-Feira',
            'Quinta-Feira',
            'Sexta-Feira',
            'Sábado',
            'Domingo'
            ]
          },
          options: {
            responsive: true,
            width:'100%',
            height:'',
            title: {
              display: true,
              text: 'Valores em Reais'
            },
            legend:{
              position:'bottom'
            }
            
          }
        });
        
        if( GlobalFunctions.isMobile()){
          this.grafico2.options.legend.display=false;
          // this.grafico1.options.legend.display=false;
        }else{
          this.grafico2.options.legend.display=true;
          // this.grafico1.options.legend.display=true;
        }
        this.grafico2.update();
        // this.grafico1.update();
      }
    },
    mounted() {
      //
    }
  }
</script>
<style>
.chart{
  width: 100%;
}
</style>
